import {
    ADMIN_ADD_UPDATE_ACCOUNT_TYPE_SUCCESS,
    ADMIN_ADD_UPDATE_ACCOUNT_TYPE_FAILED,
    LOADING_ADMIN_ADD_UPDATE_ACCOUNT_TYPE,
    RESET_ADMIN_ADD_UPDATE_ACCOUNT_TYPE,
    NETWORK_ERROR_ADMIN_ADD_UPDATE_ACCOUNT_TYPE
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADMIN_ADD_UPDATE_ACCOUNT_TYPE:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case ADMIN_ADD_UPDATE_ACCOUNT_TYPE_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case ADMIN_ADD_UPDATE_ACCOUNT_TYPE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_ADMIN_ADD_UPDATE_ACCOUNT_TYPE:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_ADMIN_ADD_UPDATE_ACCOUNT_TYPE:
            return (state = initialState);
        default:
            return state;
    }
};
